import {applyMiddleware, compose, createStore} from 'redux';
import {persistStore, persistReducer} from 'redux-persist';
import {routerMiddleware} from 'connected-react-router';
import {createBrowserHistory} from 'history';
import storage from 'redux-persist/lib/storage';
import reducer from './reducers/index';
import thunk from 'redux-thunk';
import reduxReset from 'redux-reset';

const persistConfig = {
  key: 'root',
  storage,
  // blacklist: ['source']
};

/** Configure History */
const history = createBrowserHistory();

history.listen((location, action) => {
  window.scrollTo(0, 0);
});

/** Store requirements - middleware */
const routeMiddleware = routerMiddleware(history);
const middlewares = [thunk, routeMiddleware];
const composeEnhancers = compose;
const customPersistReducer = persistReducer(persistConfig, reducer(history));

/** Configure Store */
const store = createStore(
  customPersistReducer,
  composeEnhancers(
    applyMiddleware(...middlewares),
    reduxReset()
    // window.__REDUX_DEVTOOLS_EXTENSION__ &&
    //  window.__REDUX_DEVTOOLS_EXTENSION__({trace: true})
  )
);

/** Configure Persistor */
const persistor = persistStore(store);

export {store, persistor, history};
